import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import myaxios from './axios'; //axios的全局配置

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$axios = myaxios;//这玩意放前面就报错 放这里就不报错了
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
